import { WS_ERROR_TYPES } from '../config/wsErrorTypes'; // (Создадим этот файл ниже)

/**
 * Обрабатывает ошибки WebSocket, решая, показать ли модальное окно
 * нехватки тарифа или общее уведомление об ошибке.
 *
 * @param {object | string | null} errorData - Объект ошибки от бэкенда или строка сообщения.
 * @param {object | null} wsError - Объект ошибки транспортного уровня WebSocket (если есть).
 * @param {function} openModal - Функция для открытия модальных окон (из App.js).
 * @param {function} addNotification - Функция для добавления уведомлений (из NotificationContext).
 * @param {object} [options={}] - Дополнительные опции для кастомизации уведомления.
 * @param {string} [options.defaultTitle='Error'] - Заголовок по умолчанию для общего уведомления.
 * @param {string} [options.defaultIcon='fa-exclamation-triangle'] - Иконка по умолчанию.
 * @param {string} [options.defaultColor='accent-red'] - Цвет по умолчанию.
 * @param {string} [options.moduleName='System'] - Имя модуля для логгирования.
 * @returns {string} - Возвращает извлеченное сообщение об ошибке для возможной установки локального состояния.
 */
export const handleWebSocketError = (
    errorData,
    wsError,
    openModal,
    addNotification,
    options = {}
) => {
    const {
        defaultTitle = 'Error',
        defaultIcon = 'fa-exclamation-triangle',
        defaultColor = 'accent-red',
        moduleName = 'System', // Добавляем имя модуля для ясности логов
    } = options;

    let errorMessage = "An unknown error occurred.";
    let errorCode = null; // Код ошибки, если бэкенд его передает

    // Извлекаем сообщение и код ошибки
    if (typeof errorData === 'string') {
        errorMessage = errorData;
    } else if (errorData) {
        errorMessage = errorData.message || errorData.error || errorMessage;
        errorCode = errorData.code; // Пытаемся получить код ошибки
    } else if (wsError) {
        errorMessage = wsError.message || "WebSocket transport error.";
    }

    console.error(`[${moduleName} WS Error Handler] Received error:`, errorMessage, "| Code:", errorCode, "| Raw Data:", errorData, "| WS Error:", wsError);

    const planErrorMatch = errorMessage.match(/Required: (.*?)(?: plan)?$/i);
    if (errorCode === WS_ERROR_TYPES.INSUFFICIENT_PLAN || planErrorMatch) {
        // Пытаемся извлечь требуемый тариф из сообщения (как запасной вариант)
        const requiredPlan = planErrorMatch ? planErrorMatch[1] : errorData?.requiredPlan || 'Higher Tier'; // Используем поле из DTO, если есть

        console.log(`[${moduleName} WS Error Handler] Insufficient plan detected. Required: ${requiredPlan}`);
        // Открываем специальное модальное окно
        openModal('planError', { requiredPlan });
    }
    // --- Проверка на другие специфичные ошибки по коду (если нужно) ---
    /* else if (errorCode === 'SOME_OTHER_SPECIFIC_CODE') {
        // Handle other specific errors differently if needed
    } */
    // --- Обработка всех остальных ошибок как общих уведомлений ---
    else {
        console.log(`[${moduleName} WS Error Handler] Showing general notification for error: ${errorMessage}`);
        // Показываем стандартное уведомление
        addNotification({
            id: `${moduleName.toLowerCase()}-err-${Date.now()}`, // Уникальный ID
            title: defaultTitle,
            message: errorMessage,
            icon: defaultIcon,
            color: defaultColor, // Используем цвет по умолчанию
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            read: false
        });
    }

    // Возвращаем сообщение для возможной установки в локальный стейт компонента
    return errorMessage;
};